package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
enum class AuthFlow {
    LOGIN,
    REGISTRATION
}